import React, { useState } from 'react';
import useAppState from '../../useAppState';
import { useHistory } from "react-router-dom";

import { General, AuthModal, Button } from './Signup.Style';

import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

import { authNotification } from '../../../components/notifications/fileupload_notification';
import CustomizedInputs from '../../../components/TextInput';


const Signup = () => {
  const { actions } = useAppState();
  const [data, setData] = useState({});
  let history = useHistory();

  const handleFormChange = e => {
    let authForm = {...data.form}
    authForm[e.target.name] = e.target.value;
    setData({form: authForm});
  };

  const handleFormSubmit = event => {
    event.preventDefault();

    let strongRegex = /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
    
    if(data.form.password !== data.form.password2){
      authNotification('error', 'La contraseña debe ser igual en ambos campos')();
      return
    }
    if(data.form.password.match(strongRegex) == null){
      authNotification('error', 'Tu contraseña debe ser por lo menos de 8 dígitos y debe de cumplir con al menos 1 letra mayuscula, 1 letra minuscula, 1 numero y un caracter especial')();
      return
    }
    
    setData({
      ...data,
      isSubmitting: true,
      errorMessage: null
    });
    
    actions.signup(event, data.form)
          .then(response => history.push('/login'))
          .catch(error => {
            setData({
              ...data,
              isSubmitting: false,
              errorMessage: error.message || error.statusText
            });
            authNotification('error', error.message)();
          })

  };

  return (
    <General>
      <NotificationContainer />
      <AuthModal>
        <form onSubmit={handleFormSubmit}
        style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}
        >
            <CustomizedInputs purpose={'Nombre'} name={'firstName'} handleFormChange={handleFormChange}/>
            <CustomizedInputs purpose={'Apellido'} name={'lastName'} handleFormChange={handleFormChange}/>
            <CustomizedInputs purpose={'Email'} type={'email'} name={'email'} handleFormChange={handleFormChange}/>
            <CustomizedInputs purpose={'Contraseña'} type={'password'} name={'password'}handleFormChange={handleFormChange}/>
            <CustomizedInputs purpose={'Confirmar contraseña'} type={'password'} name={'password2'} handleFormChange={handleFormChange}/>
          <Button auth disabled={data.isSubmitting}>
          {data.isSubmitting ? (
              "Cargando..."
              ) : (
                "Enviar"
                )}
          </Button>
          {/* {

          }
          { data.errorMessage && 
            authNotification('error')()
            // <div className="form-error" style={{float: "left"}}>Combinación de correo y contraseña incorrecta.</div>
            // {data.errorMessage}
          } */}
        </form>
      </AuthModal>
    </General>
  );
}

export default Signup;
